import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Chip from '@mui/material/Chip';
import { PTO_STATUS } from '../utils';

const StatusChip = props => {
  const theme = useTheme();
  const { status } = props;

  let statusText;
  let statusTextColor;
  let chipColor;

  if (status === PTO_STATUS.approvalNeeded) {
    statusText = 'Needs My Approval';
    statusTextColor = theme.palette.warning.dark;
    chipColor = theme.palette.warning.light;
  } else if (status === PTO_STATUS.pendingApproval) {
    statusText = 'Needs Recipient Approval';
    statusTextColor = theme.palette.warning.dark;
    chipColor = theme.palette.warning.light;
  } else if (status === PTO_STATUS.rejected) {
    statusText = 'Recipient Rejected';
    statusTextColor = theme.palette.graphic.dark;
    chipColor = theme.palette.graphic.light;
  } else if (status === PTO_STATUS.cancelled) {
    statusText = 'Canceled';
    statusTextColor = theme.palette.graphic.dark;
    chipColor = theme.palette.graphic.light;
  } else if (status === PTO_STATUS.expired) {
    statusText = 'Expired';
    statusTextColor = theme.palette.graphic.dark;
    chipColor = theme.palette.graphic.light;
  } else if (status === PTO_STATUS.booked) {
    statusText = 'Booked';
    statusTextColor = theme.palette.graphic.dark;
    chipColor = theme.palette.graphic.light;
  } else if (status === PTO_STATUS.approved) {
    statusText = 'Cannot Book';
    statusTextColor = theme.palette.error.dark;
    chipColor = theme.palette.error.light;
  } else if (status === PTO_STATUS.scheduled) {
    statusText = 'Scheduled';
    statusTextColor = theme.palette.primary.dark;
    chipColor = theme.palette.success.light;
  } else {
    statusText = status;
    statusTextColor = theme.palette.graphic.dark;
    chipColor = theme.palette.graphic.light;
  }

  return statusText ? (
    <Chip
      label={statusText}
      sx={{ bgcolor: chipColor, borderRadius: 16.5, color: statusTextColor }}
    />
  ) : null;
};

StatusChip.propTypes = {
  status: PropTypes.string.isRequired,
};

export default StatusChip;
